import React, {FC, useEffect, useState} from "react"

interface IPhoneMaskPlaceholder {
    value: string
    mask: string
}

const Mask:FC<IPhoneMaskPlaceholder> = ({mask, value}): React.ReactElement => {
    const [visibleMask, setVisibleMask] = useState<string>('')

    useEffect(() => {
        setVisibleMask(mask.substr(value ? value.length : 0))
    }, [value, mask])

    return <div className='select__mask'>
        <span className='hide'>{value}</span>
        <span className='visible'>{visibleMask}</span>
    </div>
}

export default React.memo(Mask)
